import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

import { UserService } from '../services/user.service';
import { ShiftMonth } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class UserShiftMonthListResolverService implements Resolve<ShiftMonth[]> {

    constructor(private userService: UserService) { }

    resolve(route: ActivatedRouteSnapshot) {
        const user = route.paramMap.get('id');
        return new Promise<ShiftMonth[]>((resolve, reject) => {
            const shifts: ShiftMonth[] = [];
            this.userService.months(+user).subscribe(
                month => shifts.push(month),
                error => reject(error),
                () => resolve(shifts)
            );
        });
    }
}
